import { render, staticRenderFns } from "./TreeCampos.vue?vue&type=template&id=31e84bfc&scoped=true&"
import script from "./TreeCampos.vue?vue&type=script&lang=js&"
export * from "./TreeCampos.vue?vue&type=script&lang=js&"
import style0 from "./TreeCampos.vue?vue&type=style&index=0&id=31e84bfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e84bfc",
  null
  
)

export default component.exports